import { BACKEND_URL } from '../../utils/settings'

const BaseModelsPopoverItem = ({
  active,
  name,
  onClick,
  price,
  baseModelId
}) => (
  <div
    onClick={onClick}
    className={
      'velorbis-customizer-gallery-popover-item ' +
      (active ? 'velorbis-customizer-gallery-popover-item-active' : '')
    }
  >
    <div className="velorbis-customizer-gallery-popover-item-img">
      <img
        src={`${BACKEND_URL}/images/thumbnails/bike-images/${baseModelId}.jpeg`}
        alt={baseModelId}
      />
    </div>
    <div className="velorbis-customizer-gallery-popover-item-name">
      <span>{name}</span>
      <span className="bold">{price}</span>
    </div>
  </div>
)

export default BaseModelsPopoverItem
